
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"65","height":"46"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon",attrs:{"fill":"none","stroke":"#c5c5c5","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"50","stroke-width":"2","d":"M23.559 32.646a12.977 12.977 0 010-18.526m-7.007 24.707c-8.296-8.526-8.296-22.35 0-30.877M10.333 45c-12.444-12.15-12.444-31.85 0-44M41.44 32.646a12.977 12.977 0 000-18.526m7 24.707c8.296-8.526 8.296-22.35 0-30.877M54.67 45c12.444-12.15 12.444-31.85 0-44M28 29v0-11 0l4.5 6.945v0L37 18v11"}})])
          )
        }
      }
    